export function getPublicAssetUrl(assetPath: string): string {
    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const normalizedPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
    return `${publicUrl}${normalizedPath}`;
}
